import ConfirmationModal from 'components/common/ConfirmationMessage';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import { usePermissions } from 'layouts/Admin';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { translationTableColor, getTranslationEyeStyle } from 'components/common/TableColor';

const TranslationListTable = ({ translations, total, currentPage, pageLength, fetchList, statusOptions = [], link, translator = true, hideHeader = false,hidePagination = false }) => {
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [sortConfig, setSortConfig] = React.useState({ sortBy: 'status', sortDirection: 'asc' });
  const [searchTerm, setSearchTerm] = React.useState("");

  //#region TABLE HEADER
  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      fetchList(currentPage, { sortBy, sortDirection: dir, search: searchTerm });
    };

    return (
      <tr>
        <th>#</th>
        <th>
          <TableHeaderItem title="TransID" sortBy="id" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th>
          <TableHeaderItem title="Name" sortBy="status" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th>
          <TableHeaderItem title="Target Language" sortBy="target_language" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th>
          <TableHeaderItem title="Department" sortBy="department" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        {translator ? (
        <th>
          <TableHeaderItem title="Translator" sortBy="translator_id" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        ):(
          <th>
          <TableHeaderItem title="Principal" sortBy="principal" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        )}
        <th>
          <TableHeaderItem title="Status" sortBy="created_at" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th>
          <TableHeaderItem title="Due Date" sortBy="created_at" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
        <th>
          <TableHeaderItem title="Received Date" sortBy="created_at" sortDirection={sortConfig.sortDirection} callBack={callBack} />
        </th>
      </tr>
    );
  }, [sortConfig, currentPage, searchTerm]);

  //#endregion

  //#region TABLE BODY
  const renderTableContent = React.useCallback(() => {
    console.log("Rendering TranslationListTable with translations:", translations);
    return translations?.map((item, index) => (
      <TranslationListItem
        key={item.id}
        item={item}
        index={index}
        link={link}
        translator={translator}
        currentPage={currentPage}
        pageLength={pageLength}
      />
    ));
  }, [translations, currentPage, pageLength]);
  //#endregion

  return (
    <div className='mt-4'>
      <ListLayout
        heading="Today's Translations"
        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        fetchList={fetchList}
        selectedItems={selectedItems}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        searchPlaceholder="Search translations..."
        totalPages={Math?.ceil(total / pageLength)}
        sortConfig={sortConfig}
        addButtonDisabled={true}
        hideHeader={hideHeader}
        hidePagination={hidePagination}
        noOfItems={total}
      />
    </div>
  );
};

const TranslationListItem = React.memo(({ item, index, currentPage, pageLength, link, translator }) => {
  const serial = useMemo(() => index + 1 + (currentPage - 1) * pageLength, [index, currentPage, pageLength]);
  const formattedDate = item?.created_at ? moment(item.created_at).format('MMM D, YYYY HH:mm') : 'N/A';
  const onlyDate = new Date(item?.created_at).toISOString().split("T")[0];
  return (
    <tr>
      {/* <td>{serial}</td>
      <td>{item?.id || 'N/A'}</td>
      <td style={getBackgroundStyle(item?.status)}>{item?.status || 'N/A'}</td>
      <td>{item?.source_language?.name || 'N/A'}</td>
      <td>{item?.target_language?.name || 'N/A'}</td>
      <td>{item?.translator?.name || 'N/A'}</td>
      <td>{formattedDate}</td> */}
      <td className='p-0' style={translationTableColor(item?.status)}>
          <div className={`eye_area  ${item?.appointment_details?.extra_mileage_request == 1 && 'extra-mileage'}`} style={getTranslationEyeStyle(item?.status)}>
              <Link to={`/${link}/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
          </div>
      </td>
      <td style={translationTableColor(item?.status)}>
          {item?.transid || 'N/A'}
      </td>
      <td style={translationTableColor(item?.status)}>
          {item?.requester_name || 'N/A'}
      </td>
      <td style={translationTableColor(item?.status)}>
          {item?.department || 'N/A'}
      </td>
      <td style={translationTableColor(item?.status)}>
          {item?.translation_target_languages[0]?.language?.name || 'N/A'}
      </td>
      {translator ? (
      <td style={translationTableColor(item?.status)}>
          {item?.interpreter?.user?.name || 'N/A'}
      </td>
      ) : (
        <td style={translationTableColor(item?.status)}>
          {item?.principal || 'N/A'}
      </td>
      )}
      <td style={translationTableColor(item?.status)}>
          {item?.status || 'N/A'}
      </td>
      <td style={translationTableColor(item?.status)}>
          {item?.translation_details?.due_date || 'N/A'}
      </td>
      <td style={translationTableColor(item?.status)}>
          {onlyDate}
      </td>
    </tr>
  );
});

export default TranslationListTable;